import { createContext, useState } from "react";
import axios from "axios";

const QuestionContext = createContext();

const QuestionProvider = ({ children }) => {
  const [questions, setQuestions] = useState([]);

  const getQuestions = async () => {
    try {
      const response = await axios.get("/mcqs");
      setQuestions(response?.data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <QuestionContext.Provider value={{ questions, getQuestions }}>
      {children}
    </QuestionContext.Provider>
  );
};

export { QuestionProvider, QuestionContext };
